
export const prototypeName = 'PPxANG1LQncky7A5azeNSVL77vodN8SDlNANDg8Nc25axAZ24Jub3QX7xN7oUjZ9er2';